export default {
  namespaced: true,

  state: {
    loadingCount: 0,
  },

  getters: {
    loadingCount: (state) => state.loadingCount,
    isLoading: (state) => state.loadingCount > 0,
  },

  mutations: {
    START_LOADING(state) {
      state.loadingCount++;
    },

    END_LOADING(state) {
      if (state.loadingCount > 0) {
        state.loadingCount--;
      }
    },

    RESET_LOADING(state) {
      state.loadingCount = 0;
    },
  },
};